var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link pointer-click",on:{"click":function($event){return _vm.openNotificationModal()}}},[_c('i',{staticClass:"fas fa-bell fa-fw"}),_vm._v(" "),(_vm.totalLabel > 0)?_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.totalLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }